import React, { FC, useEffect, useState } from 'react';
import { Modal, Tabs } from 'antd';
import { Delivery, Pin } from 'common/svg';
import { priceFormatter } from 'common/helpers';
import { EDeliveryType, IBasket, IBasketDelivery, IBasketGoods, IUpdateBasketPayload } from 'entities/Basket/Basket.models';
import { DeliveryMethod, PickUpMethod } from 'entities/Basket/components';
import { IAddress } from 'entities/Address/Address.models';

interface IComponentProps {
  open: boolean;
  basket: IBasket;
  selectedGoods: IBasketGoods[];
  delivery: IBasketDelivery;
  onAddressChange: (address: IAddress) => void;
  onCancel: () => void;
  onSubmit: (payload: Omit<IUpdateBasketPayload, 'id'>) => void;
}

export const BasketDeliveryModal: FC<IComponentProps> = ({
  open,
  basket,
  selectedGoods,
  delivery,
  onAddressChange,
  onCancel,
  onSubmit,
}) => {
  const [tab, setTab] = useState<EDeliveryType>(EDeliveryType.PickUp);

  useEffect(() => {
    if (open && basket.deliveryType) {
      setTab(basket.deliveryType as EDeliveryType);
    }

    if (!open) {
      setTab(EDeliveryType.PickUp);
    }
  }, [open, basket.deliveryType]);

  const handleTabChange = (key: string): void => {
    setTab(key as EDeliveryType);
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={680}
      centered
      open={open}
      footer={null}
      mask={false}
      destroyOnClose
      onCancel={onCancel}
    >
      <div className="mb-6 ff-medium fs-l">Выберите способ доставки</div>

      <Tabs
        className="basket-delivery-modal__tabs"
        activeKey={tab}
        onChange={handleTabChange}
        items={[
          {
            key: EDeliveryType.PickUp,
            label: (
              <div className="flex align-center">
                <Pin className="mr-3 icon-dark-grey" />
                <span>
                  <span className="mr-2 ff-semibold fs-xs color-black">Самовывоз:</span>
                  <span className="ff-regular fs-xs color-black">бесплатно</span>
                </span>
              </div>
            ),
            children: <PickUpMethod basket={basket} onSubmit={onSubmit} />,
          },
          {
            key: EDeliveryType.Delivery,
            label: (
              <div className="flex align-center">
                <Delivery className="mr-3 icon-delivery-dark-grey icon-delivery" />
                <span>
                  <span className="mr-2 ff-semibold fs-xs color-black">Доставка курьером:</span>
                  <span className="ff-regular fs-xs color-black">{priceFormatter(delivery.deliveryPriceWithTaxes)}</span>
                </span>
              </div>
            ),
            children: (
              <DeliveryMethod
                basket={basket}
                selectedGoods={selectedGoods}
                delivery={delivery}
                onAddressChange={onAddressChange}
                onSubmit={onSubmit}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};
